export default __webpack_public_path__ + "static/media/Helm of Black Spite.c4da068d.jpg";